// Module
var code = "<!-- Input search -->\n<cjs-input-search ref=\"inputSearch\" class=\"flex-container-row flex-item-auto\"></cjs-input-search>";
// Exports
module.exports = code;